<!-- Form -->
@if (form) {
  <medsurf-design-form-control-form
    [formGroup]="form"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2">
      <!-- Label -->
      <medsurf-editor [formField]="false"
        [control]="form.controls.content"
        label="global.question_text"
        placeholder="global.question_text"
      (valueChange)="onSubmit()"></medsurf-editor>
      <!-- Solution -->
      <medsurf-design-form-control-input-select-button [class]="'w-full'"
        [control]="form.controls.solution"
        [options]="FlatModels.QuestionEntityModels.TrueFalseQuestionSolutionArray"
        [allowEmpty]="false"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-select-button>
      <!-- Explanation -->
      <medsurf-editor [formField]="false"
        [control]="form.controls.explanation"
        label="global.explanation_text"
        placeholder="global.explanation_text_description"
      (valueChange)="onSubmit()"></medsurf-editor>
    </div>
  </medsurf-design-form-control-form>
}